"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = encodeQuery;

var _flattenDeepPropertyList = _interopRequireDefault(require("../flattenDeepPropertyList"));

var _recursiveBracket = _interopRequireDefault(require("../recursiveBracket"));

/**
 * Encode un objet vers le format query-string.
 * @param {object} obj
 * @param {object} options
 * @param {boolean} [options.appendPrefix=false]
 * @param {boolean} [options.useEmptySpacesForNumerics=true]
 * @param {boolean} [options.castBooleans=true]
 * @param {boolean} [options.removeEmptyStrings=true]
 * @param {boolean} [options.removeNull=true]
 * @return {string}
 */
function encodeQuery(obj, options = {}) {
  const {
    appendPrefix = false,
    useEmptySpacesForNumerics = true,
    castBooleans = true,
    removeEmptyStrings = true,
    removeNull = true
  } = options;
  const flattenKeyValueList = (0, _flattenDeepPropertyList.default)(obj);

  if (flattenKeyValueList.length === 0) {
    return "";
  }

  const query = flattenKeyValueList.reduce((keyListAcc, [keyList, value]) => {
    const tempKeyList = useEmptySpacesForNumerics ? keyList.map(key => {
      return !isNaN(parseInt(key)) ? "" : key;
    }) : keyList;

    if (undefined !== value && (!removeNull || null !== value) && (!removeEmptyStrings || value !== "")) {
      if (castBooleans && "boolean" === typeof value) {
        value = value ? "1" : "0";
      }

      if (null === value) {
        value = "";
      }

      keyListAcc.push(`${(0, _recursiveBracket.default)(tempKeyList)}=${value}`);
    }

    return keyListAcc;
  }, []).join("&");
  return appendPrefix && query.length > 0 ? `?${query}` : query;
}